import requestWrapper from '../../requestWrapper';
import endpoints from './endpoints';
import type {
	CopyrightClaim,
	CopyrightClaimActiveFilterType,
	CopyrightClaimCreateForm,
	SolvePayload,
} from './types';
import type {DataResponseWrapper} from '@deezer/next/services/api/Starmania/requests/types';

const {paginatedGet, post, patch, get} = requestWrapper;

const requests = {
	getCopyrightClaims: (filters?: CopyrightClaimActiveFilterType) => {
		return paginatedGet<CopyrightClaim[]>(endpoints.copyrightClaims, {
			params: {
				albumUpc: filters?.upc || undefined,
				trackIsrc: filters?.isrc || undefined,
				claimantEmail: filters?.claimantEmail || undefined,
				entityId: filters?.contentId || undefined,
				pastDue: filters?.isPastDue || undefined,
			},
		});
	},
	getCopyrightClaim: (id: number) =>
		get<DataResponseWrapper<CopyrightClaim>>(endpoints.copyrightClaim(id)),
	createCopyrightClaim: (data: CopyrightClaimCreateForm) =>
		post<DataResponseWrapper<{message: string; copyrightClaimId: number}>>(
			endpoints.copyrightClaims,
			data,
		),
	solveCase: (
		claimId: number,
		caseId: number,
		data: {feedbacks: SolvePayload[]; comment: string},
	) =>
		patch<DataResponseWrapper<{message: string}>>(
			endpoints.solveCase(claimId, caseId),
			data,
		),
	banContent: (claimId: number, contentId: number) =>
		post<DataResponseWrapper<{status: string; detail: string}>>(
			endpoints.banContent(claimId, contentId),
		),
	updateCaseEmail: (claimId: number, caseId: number, email: string) =>
		patch<DataResponseWrapper<{message: string}>>(
			endpoints.case(claimId, caseId),
			{email},
		),
	cancelClaim: (claimId: number) =>
		patch<DataResponseWrapper<{message: string}>>(
			endpoints.denyClaim(claimId),
			{deny: true},
		),
	acknowledgeCopyrightClaim: (claimId: number) =>
		patch<DataResponseWrapper<{message: string}>>(
			endpoints.acknowledgeCopyrightClaim(claimId),
			{acknowledge: true},
		),
};

export default requests;
